import { BasketStatus } from '@edgebox/data-definitions';
import React from 'react';
import Badge from 'react-bootstrap/Badge';
import { DataDefinitionsEnumValue } from '../../Localization/DataDefinitionsEnumValue';

interface IProps {
  status: BasketStatus;
  size?: 'small';
}

export class BasketStatusBadge extends React.Component<IProps, {}> {
  render(): React.ReactElement {
    const { status, size } = this.props;

    const classes = size ? 'small' : '';

    const variants = {
      [BasketStatus.Created]: 'light',
      [BasketStatus.Proposal]: 'light',
      [BasketStatus.Purchased]: 'primary',
      [BasketStatus.Requested]: 'warning',
      [BasketStatus.Obsolete]: 'dark',
    };

    return (
      <Badge bg={variants[status]} className={classes}>
        <DataDefinitionsEnumValue enumName={'BasketStatus'} keyName={status} />
      </Badge>
    );
  }
}
